import { Injectable } from '@angular/core';

import { environment } from '../../../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class TrackAnalyticsService {

  sendEvent(category: string, event: string, label = 'leadin'): void {
    if (environment.stage !== 'dev') {
      (window as any).ga('send', 'event', {
        eventCategory: category,
        eventLabel: label,
        eventAction: event,
        eventValue: 10
      });
    }
  }
}
